import styled from "styled-components";

export const ErrorPage = styled.div`
  padding: 12px;
  min-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
  background-color: #fff;
`;

export const ErrorContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorTitle = styled.div`
  color: #999;
  font-size: 14px;
  margin-bottom: 32px;
`;

export const ErrorDesc = styled.div`
  color: #999;
  margin-top: 8px;
  text-align: left;
  font-size: 12px;
`;
